require("sweetalert");

if ('serviceWorker' in navigator) {
    navigator
        .serviceWorker
        .register('/service-worker.js')
        .then(function (reg) {
            console.log('Service worker registered successfully!!!', reg);
        })
}

let installPromptEvent;

window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    installPromptEvent = event;
});

let btnInstall = document.querySelector('#add-banner');

if (btnInstall) {
    btnInstall.addEventListener('click', () => {
        if(installPromptEvent) {
            installPromptEvent.prompt();

            installPromptEvent
                .userChoice
                .then((choice) => {
                    if (choice.outcome === 'accepted') {
                        console.log('User accepted the A2HS prompt');
                    } else {
                        console.log('User dismissed the A2HS prompt');
                    }
                    // Clear the saved prompt since it can't be used again
                    installPromptEvent = null;
                });
        }
    });
}

// add img-fluid to all images

let getUrlParameter = function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

let fileLable = $('input:file');
fileLable.on('change', function () {
    let fileName = $(this).val();
    $(this).siblings($('label')).html('<span class="Verdana text-start">' + fileName + '</span>');
});

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
});

// disable Prev Button in Browsers
// Chrome
function disablePrev() {
    window.history.forward()
}
window.onload = disablePrev();
window.onpageshow = function (evt) {
    if (evt.persisted) disableBack()
}

// Firefox
window.history.pushState(null, "", window.location.href);
window.onpopstate = function() {
    window.history.pushState(null, "", window.location.href);
};

$('input.numeric').keyup(function(event) {
    if(event.which >= 37 && event.which <= 40){
        event.preventDefault();
    }

    $(this).val(function(index, value) {
        return value
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    });
});

// selectAll();
let selectAll = $('input#select-all');
let permissions = $('input.permissions');
let roles = $('input.roles');

// input#select-all on checked
selectAll.on('change', function () {
    $('input:checkbox').prop('checked', selectAll.prop('checked'));
});
// input.permissions on change
// for (input#select-all) & (input.roles) checked
permissions.on('change', function () {
    if ($('input.permissions:checkbox').not(selectAll).length === $('input.permissions:checkbox:checked').not(selectAll).length) {
        selectAll.prop('checked', true)
    } else {
        selectAll.prop('checked', false)
    }

    let currRole = $(this).parents('div.card').first().find('input.roles:checkbox');
    let tPermissions = $(this).parents('div.card').first().find('input.permissions:checkbox');

    if (tPermissions.length === $(this).parents('div.card').first().find('input.permissions:checkbox:checked').length) {
        currRole.prop('checked', true)
    } else {
        currRole.prop('checked', false)
    }
});
// input.roles on change
// for (input#select-all) & (input.permissions)
roles.on('change', function () {
    let currentRole = $(this);
    let thisPermissions = currentRole.parents('div.card').first().find('input.permissions:checkbox');

    thisPermissions.prop('checked', currentRole.prop('checked'));

    if ($('input.permissions:checkbox').not(selectAll).length === $('input.permissions:checkbox:checked').not(selectAll).length) {
        selectAll.prop('checked', true)
    } else {
        selectAll.prop('checked', false)
    }
});

// load document
// for (input#select-all)
if (permissions.length == $('input.permissions:checkbox:checked').length) {
    selectAll.prop('checked', true)
} else {
    selectAll.prop('checked', false)
}
// load document
// for (input.roles)
$('input.permissions:checkbox:checked').each(function() {
    let currRoleEdit = $(this).parents('div.card').first().find('input.roles:checkbox');
    let tPermissionsEdit = $(this).parents('div.card').first().find('input.permissions:checkbox');

    if (tPermissionsEdit.length === $(this).parents('div.card').first().find('input.permissions:checkbox:checked').length) {
        currRoleEdit.prop('checked', true)
    } else {
        currRoleEdit.prop('checked', false)
    }
});

function checkTime(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

// get live time
function startTime() {
    let today = new Date();
    let h = today.getHours();
    let m = today.getMinutes();
    let s = today.getSeconds();
    // add a zero in front of numbers<1
    m = checkTime(m);
    s = checkTime(s);
    document.getElementById('time').innerHTML = h + ":" + m + ":" + s;
    setTimeout(function() {
        startTime()
    }, 500);
}
startTime();

document.addEventListener("keyup", function (e) {
    var keyCode = e.keyCode ? e.keyCode : e.which;
    if (keyCode == 44) {
        stopPrntScr();
    }
});

function stopPrntScr() {
    var inpFld = document.createElement("input");
    inpFld.setAttribute("value", ".");
    inpFld.setAttribute("width", "0");
    inpFld.style.height = "0px";
    inpFld.style.width = "0px";
    inpFld.style.border = "0px";
    document.body.appendChild(inpFld);
    inpFld.select();
    document.execCommand("copy");
    inpFld.remove(inpFld);
}
function AccessClipboardData() {
    try {
        window.clipboardData.setData('text', "Access Restricted");
    } catch (err) {
    }
}
setInterval("AccessClipboardData()", 300);

$('form').one('submit', function () {
    $('form').on('submit', function (e) {
        e.preventDefault();
    });
});
